import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'Pianificazione Costante delle Sessioni',
  description: 'Passi ore ogni settimana cercando di creare nuove lezioni sicure, coinvolgenti e adatte a diversi livelli di mobilità.'
}, {
  emoji: '⚠️',
  title: 'Paura di Fare Troppo... o Troppo Poco',
  description: 'Ti chiedi continuamente se un esercizio è troppo difficile, troppo facile o inadatto per le persone che hai davanti.'
}, {
  emoji: '📚',
  title: 'Informazioni Ovunque',
  description: 'Puoi trovare esercizi online, ma niente è organizzato in un sistema di allenamento completo che tu possa davvero seguire ogni giorno.'
}, {
  emoji: '😩',
  title: 'Esaurimento Mentale',
  description: 'Tra pianificazione, allenamento, motivazione e gestione delle classi, ti rimane poco tempo per ciò che conta: aiutare le persone a invecchiare meglio.'
}];
export function PainSection() {
  return <section className="py-10 px-4 sm:px-6 bg-ivory" data-id="element-129">
      <h2 className="text-2xl sm:text-4xl font-heading font-bold text-center text-petrol mb-3 leading-tight uppercase" data-id="element-130">
        Ti Riconosci in Questo?
      </h2>

      <p className="text-sm sm:text-lg text-graphite font-subheading font-semibold text-center mb-8 max-w-2xl mx-auto leading-snug" data-id="element-131">
        Ami aiutare gli adulti maggiori a mantenersi attivi, ma la
        pianificazione consuma tutta la tua settimana?
        <br data-id="element-132" />
        <span className="text-sage font-bold" data-id="element-133">
          Se lavori con persone anziane, probabilmente conosci almeno una di
          queste situazioni:
        </span>
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-4xl mx-auto" data-id="element-134">
        {pains.map((pain, i) => <div key={i} className="bg-cream p-5 rounded-xl border-l-4 border-gold shadow-md flex flex-col gap-3 hover:border-petrol transition-colors" data-id="element-135">
            <div className="text-3xl leading-none" data-id="element-136">{pain.emoji}</div>
            <div data-id="element-137">
              <h3 className="text-base sm:text-lg font-bold text-petrol mb-1.5 font-body uppercase tracking-wide" data-id="element-138">
                {pain.title}
              </h3>
              <p className="text-graphite text-sm sm:text-base leading-relaxed" data-id="element-139">
                {pain.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}